import React from "react";
import { Anchor, Group, Text } from "@mantine/core";
import type { ContentItem } from "@/pages/ClientProfile/types";
import { useStyles } from "../../../styles/styles";
import { IconFile } from "@tabler/icons-react";

interface DocumentItemProps {
  item: ContentItem & {
    type: "document";
    url: string;
    label: string;
    fileType: string;
    indentLevel: number;
  };
}

const DocumentItem: React.FC<DocumentItemProps> = ({ item }) => {
  const { classes } = useStyles();

  return (
    <Anchor
      href={item.url}
      target="_blank"
      rel="noopener noreferrer"
      className={classes.document}
      style={{ textDecoration: "none" }}
      ml="lg"
    >
      <Group>
        <IconFile size={20} />
        <Text size="sm" fw={500}>
          {item.label}
        </Text>
      </Group>
    </Anchor>
  );
};

export default DocumentItem;
